module.exports = __webpack_public_path__ + "img/BV.b197b254.png";